<template>
  <div
    v-lazyscript="{ url: 'https://www.youtube.com/player_api', name: 'youtube' }"
    class="video-component"
  >
    <div :class="'embed-responsive embed-responsive-' + aspectratio">
      <div v-if="videoid !== ''" :id="playerId" class="embed-responsive-item"></div>
    </div>
    <slot></slot>
    <img
      v-if="!!$slots.default ? false : true"
      alt="yout tube preload image"
      data-srcset="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88x8AAp0BzdNtlUkAAAAASUVORK5CYII="
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88x8AAp0BzdNtlUkAAAAASUVORK5CYII="
      class="placeholder lazyload"
    />
    <button
      v-if="videoid !== ''"
      ref="playbtn"
      class="play-btn"
      title="play or pause video"
      :aria-label="ariaLabel"
      @click.once="togglePlaceholder()"
    >
      <span></span>
    </button>
  </div>
</template>

<script>
/* global YT */

import { animate } from 'animejs';

export default {
  name: 'videoplaceholder',
  props: {
    videoid: { required: false, type: String, default: '' },
    aspectratio: { required: false, type: String, default: '16by9' }, // aspect ratio can be 16by9 and 4by3
    lazyPoster: { required: false, type: Boolean, default: false },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      playerId: `player-${this.videoid}-${Date.now()}`,
      placeholder: null,
      player: null,
      playbackListener: false,
      duration: 0,
      playerRendered: false,
      videoPlaceholderImg: false,
    };
  },

  computed: {
    hasPoster() {
      return !!this.$slots.default;
    },
  },
  mounted() {
    /* istanbul ignore if */
    if (this.videoid === '') {
      return;
    }
    this.placeholder = this.$el.querySelector('.placeholder');
  },

  methods: {
    togglePlaceholder() {
      const yPos = window.scrollY;
      window.scrollTo(0, yPos + 5);
      this.animatePoster().then(() => {
        this.placeholder.style.display = 'none';
        this.$refs.playbtn.style.display = 'none';
        // in case the player is not ready.
        try {
          this.setupPlayerAndBindToEvents();
        } catch {
          setTimeout(() => {
            this.setupPlayerAndBindToEvents();
          }, 500);
        }
      });
    },

    animatePoster() {
      return new Promise((resolve) => {
        animate([this.placeholder, this.$refs.playbtn], {
          opacity: { to: 0, duration: 500 },
          onComplete: resolve(),
        });
      });
    },

    setupPlayerAndBindToEvents() {
      /* istanbul ignore next */
      this.setupYT().then(() => {
        this.player = new YT.Player(this.playerId, {
          playerVars: {
            showinfo: 0,
            rel: 0,
            modestbranding: 1,
          },
          videoId: this.videoid,
          events: {
            onReady: () => {
              this.playerRendered = true;
              this.player.playVideo();
            },
          },
        });
      });
    },

    setupYT() {
      return new Promise((resolve) => {
        let interval = false;
        interval = setInterval(() => {
          if (typeof YT !== 'undefined' && YT.loaded === 1 && typeof YT.Player !== 'undefined') {
            clearInterval(interval);
            resolve(YT);
          }
        }, 100);
      });
    },
  },
};
</script>

<style lang="scss" src="./video-placeholder.scss"></style>
